import { skipToken, useInfiniteQuery } from '@tanstack/react-query';
import merge from 'lodash/merge';

import { Boards } from '@air/api';
import { type BoardsListOptions, type BoardsListResponse, type Workspace } from '@air/api/types';

export const BOARDS_LIST_KEY = '@plugin-ui/BOARDS_LIST';

export const getBoardsListKey = (params?: UseBoardsListParams) => {
  return [BOARDS_LIST_KEY, params];
};

export type UseBoardsListParams = BoardsListOptions & {
  workspaceId: Workspace['id'] | undefined;
};

export const BOARDS_LIST_DEFAULT_PARAMS: Partial<UseBoardsListParams> = {
  limit: 50,
  numThumbnails: 4,
};

export const useBoardsList = (params: UseBoardsListParams) => {
  const mergedParams = merge({}, BOARDS_LIST_DEFAULT_PARAMS, params);
  const { workspaceId } = mergedParams;

  return useInfiniteQuery({
    getNextPageParam: (lastPage: BoardsListResponse) => lastPage?.pagination?.cursor,
    initialPageParam: '',
    queryFn: workspaceId
      ? ({ pageParam }) =>
          Boards.list({
            ...mergedParams,
            cursor: pageParam || null,
            workspaceId,
          })
      : skipToken,
    queryKey: getBoardsListKey(mergedParams),
  });
};
